import { render, staticRenderFns } from "./SyntaxInformation.vue?vue&type=template&id=693f5df9&"
import script from "./SyntaxInformation.vue?vue&type=script&lang=js&"
export * from "./SyntaxInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports